import { Plugin } from 'vue'
import VueMqDdExtension from './vue-mq-dd-extension'

declare module 'vue' {
  interface ComponentCustomProperties {
    $screen: VueMqDdExtension
  }
}

export default {
  install(app) {
    app.config.globalProperties.$screen = new VueMqDdExtension()
  },
} as Plugin
